import { moodLabel, type MoodWord } from '@adhd/shared';

/**
 * Which of the seven conditions a mood falls in, as a CSS-friendly key.
 *
 * DERIVED FROM THE WORD, NOT FROM A SECOND TABLE OF BOUNDS. moodLabel is the
 * one authority on the bands (see MOOD_WORDS in @adhd/shared, and why it is a
 * chain rather than a table); this maps each word to the token that colours a
 * cell or tints a block — --c-awful … --c-great in tokens.css. A table of
 * integers here would be the fourth statement of the scale.
 */
export type Band = 'awful' | 'rough' | 'low' | 'neutral' | 'alright' | 'good' | 'great';

const BAND_OF_WORD: Record<MoodWord, Band> = {
  Awful: 'awful',
  Rough: 'rough',
  'A bit low': 'low',
  Neutral: 'neutral',
  Alright: 'alright',
  Good: 'good',
  Great: 'great',
};

export const bandOf = (mood: number): Band => BAND_OF_WORD[moodLabel(mood)];

/**
 * The text colour that reads on a condition colour. Measured on 13 Oct 2026:
 * white holds 5.4–8.5:1 on awful, rough and neutral; ink holds 4.4–5.2:1 on
 * alright, good and great; low is the borderline one (4.3 either way) and
 * takes white, which also keeps the warm half of the scale one colour of text.
 */
export const inkOn = (band: Band): 'light' | 'dark' =>
  band === 'alright' || band === 'good' || band === 'great' ? 'dark' : 'light';
